import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const badgeVariants = cva(
  'inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors',
  {
    variants: {
      variant: {
        default: 'border-transparent bg-accent-cyan/20 text-accent-cyan',
        emerald: 'border-transparent bg-accent-emerald-dim text-accent-emerald',
        amber: 'border-transparent bg-accent-amber-dim text-accent-amber',
        rose: 'border-transparent bg-accent-rose-dim text-accent-rose',
        sky: 'border-transparent bg-accent-sky-dim text-accent-sky',
        violet: 'border-transparent bg-accent-violet-dim text-accent-violet',
        muted: 'border-transparent bg-bg-surface-2 text-text-secondary',
        outline: 'border-border-subtle text-text-secondary',
        // outlined status variants — border only, no fill, visually distinct from solid severity badges
        'outline-amber': 'border-accent-amber/60 bg-transparent text-accent-amber',
        'outline-emerald': 'border-accent-emerald/60 bg-transparent text-accent-emerald',
        'outline-sky': 'border-accent-sky/60 bg-transparent text-accent-sky',
        'outline-muted': 'border-border-subtle bg-transparent text-text-secondary',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
